import { gsap } from 'gsap';
import './numbers.scss';

const COMPONENT_SELECTOR = '.numbers-columns';
const COUNT_SELECTOR = '.numbers__count';
const ANIMATION_DURATION = 3;
const INTERSECTION_THRESHOLD = 0.5;

/**
 * version    1.1
 * class      Numbers
 * classdesc  Component that manages the numbers section with count-up animation.
 *            Uses IntersectionObserver to trigger the animation when the section
 *            enters the viewport, and GSAP to animate each .numbers__count element
 *            from 0 to the value specified in its data-count-to attribute.
 */
export class Numbers {
  constructor() {
    this._section = document.querySelector(COMPONENT_SELECTOR);
    if (!this._section) return;

    this._countEls = this._section.querySelectorAll(COUNT_SELECTOR);
    if (!this._countEls.length) return;

    this._initCountUp();
  }

  // private methods

  _initCountUp() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this._animateCounts();
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: INTERSECTION_THRESHOLD },
    );

    observer.observe(this._section);
  }

  _animateCounts() {
    this._countEls.forEach((el) => {
      const target = parseInt(el.dataset.countTo, 10);
      if (Number.isNaN(target)) return;

      const obj = { value: 0 };

      gsap.to(obj, {
        value: target,
        duration: ANIMATION_DURATION,
        ease: 'power2.out',
        onUpdate() {
          el.textContent = Math.round(obj.value); // eslint-disable-line no-param-reassign
        },
      });
    });
  }
}
